import styled from '../../config/theme'

const Container = styled.div`
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  > button {
    margin: 0 10px;
  }
`

export {
  Container,
}
